module.exports = __webpack_public_path__ + "img/phone-screen.5e585af3.png";